import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  catchError,
  map,
  publishReplay,
  refCount,
  throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { Published } from '../models/published.model';

@Injectable({
  providedIn: 'root',
})
export class PublishedService {
  slug = '/published';

  allPublished?: Observable<any[]>[] | null | any = {};
  allLibrary?: Observable<any[]> | null = null;

  constructor(private http: HttpClient) {}
  fetchAll(scenarioId: any): Observable<any[]> {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('scenario_id', scenarioId.toString());

    if (!this.allPublished[scenarioId]) {
      this.allPublished[scenarioId] = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
          params: searchParams,
        })
        .pipe(
          map((responseData) => {
            return responseData._embedded.published;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount(),
        );
    }

    return this.allPublished[scenarioId];
  }

  clearCache() {
    this.allPublished = {};
    this.allLibrary = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          const item = new Published(
            +responseData.published_id,
            responseData.hash,
            +responseData.scenario_id,
            +responseData.user_id,
            responseData.version,
            responseData.title,
            responseData.config,
            responseData.player_version,
            responseData.status,
            responseData.created,
            responseData.modified,
          );
          return item;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  create(scenario_id: number, version: string, title: string, config: string) {
    this.clearCache();
    const payload = {
      scenario_id,
      version,
      title,
      config,
    };
    return this.http.post<Published>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, version: string, title: string, config: string) {
    this.clearCache();
    var payload: any = { title, config };
    if (version) {
      payload.version = version;
    }
    return this.http.patch<Published>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      },
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id,
    );
  }

  buildHtml(published_id: number) {
    this.clearCache();
    const payload = {
      published_id,
    };
    return this.http.post<any>(environment.apiUrl + '/build_html', payload, {
      observe: 'response',
    });
  }

  buildScorm(published_id: number, analytics: boolean) {
    this.clearCache();
    const payload = {
      published_id,
      analytics,
    };
    return this.http.post<any>(environment.apiUrl + '/build_scorm', payload, {
      observe: 'response',
    });
  }

  buildXapi(
    published_id: number,
    lrsEndpoint: string,
    lrsUsername: string,
    lrsPassword: string,
    activityId: string,
    activityName: string,
    activityDescription: string,
    actor: string,
    scorm: boolean,
  ) {
    this.clearCache();
    const payload = {
      published_id,
      lrs_endpoint: lrsEndpoint,
      lrs_username: lrsUsername,
      lrs_password: lrsPassword,
      activity_id: activityId,
      activity_name: activityName,
      activity_description: activityDescription,
      actor,
      scorm,
    };
    return this.http.post<any>(environment.apiUrl + '/build_xapi', payload, {
      observe: 'response',
    });
  }

  fetchLibrary(): Observable<any[]> {
    if (!this.allLibrary) {
      let searchParams = new HttpParams();
      searchParams = searchParams.append('library', 1);
      this.allLibrary = this.http
        .get<any>(environment.apiUrl + '/published', {
          //environment.apiUrl + this.slug
          responseType: 'json',
          params: searchParams,
        })
        .pipe(
          map((responseData) => {
            return responseData._embedded.published;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount(),
        );
    }

    return this.allLibrary;
  }
}
